module.exports = __webpack_public_path__ + "img/csm_Geschichte_Einst-und-heute_01_12df3f7140.9c8ccf43.jpg";